import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

// core components
import Admin from "layouts/Admin.jsx";
import Dashboard from "layouts/Dashboard.jsx";

import "assets/css/material-dashboard-react.css?v=1.7.0";
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import "assets/css/app.css?v=1.7.0";

const hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      <Route path="/admin" component={Admin} />
      <Route path="/login" component={Dashboard} />
      <Redirect from="/" to="/login/login" />
    </Switch>
  </Router>,
  document.getElementById("root")
);